export { default as FirstPaymentAuthorizationForm } from './FirstPaymentAuthorizationForm';
